import { useState, useRef, useEffect } from "react";

export default function ChatWidget({ onNavigate }) {
    const [open, setOpen] = useState(false);
    const [messages, setMessages] = useState([
        {
            role: "assistant",
            content: "Bonjour ! Je suis l'assistant Solvya 👋 Comment puis-je vous aider ?"
        }
    ]);
    const [input, setInput] = useState("");
    const [loading, setLoading] = useState(false);
    const [showHandoff, setShowHandoff] = useState(false);
    const messagesEndRef = useRef(null);

    useEffect(() => {
        if (open) {
            messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
        }
    }, [messages, open]);

    const sendMessage = async () => {
        if (!input.trim() || loading) return;

        const userMessage = { role: "user", content: input.trim() };
        const newMessages = [...messages, userMessage];
        setMessages(newMessages);
        setInput("");
        setLoading(true);

        try {
            const API = process.env.REACT_APP_API_URL || "http://localhost:3001";
            const response = await fetch(`${API}/chat`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    messages: newMessages.map(m => ({ role: m.role, content: m.content }))
                })
            });

            const data = await response.json();
            const assistantMessage = {
                role: "assistant",
                content: data.content || "Désolé, je n'ai pas pu répondre."
            };

            setMessages(prev => [...prev, assistantMessage]);

            if (newMessages.filter(m => m.role === "user").length >= 2) {
                setShowHandoff(true);
            }
        } catch {
            setMessages(prev => [...prev, {
                role: "assistant",
                content: "Une erreur est survenue. Veuillez réessayer ou contacter le support directement."
            }]);
        }

        setLoading(false);
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter" && !e.shiftKey) {
            e.preventDefault();
            sendMessage();
        }
    };

    return (
        <>
            {/* Widget ouvert */}
            {open && (
                <div style={{
                    position: "fixed",
                    bottom: 80,
                    right: 24,
                    width: 360,
                    maxHeight: 520,
                    display: "flex",
                    flexDirection: "column",
                    background: "rgba(18,20,28,0.97)",
                    border: "1px solid rgba(255,255,255,0.10)",
                    borderRadius: 18,
                    boxShadow: "0 24px 60px rgba(0,0,0,0.6)",
                    backdropFilter: "blur(16px)",
                    zIndex: 1000,
                    overflow: "hidden"
                }}>
                    {/* Header */}
                    <div style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        padding: "14px 16px",
                        borderBottom: "1px solid rgba(255,255,255,0.07)",
                        background: "rgba(110,86,207,0.10)"
                    }}>
                        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                            <div style={{
                                width: 32, height: 32, borderRadius: "50%",
                                background: "rgba(110,86,207,0.25)",
                                border: "1px solid rgba(110,86,207,0.4)",
                                display: "flex", alignItems: "center", justifyContent: "center",
                                fontSize: 16
                            }}>🤖</div>
                            <div>
                                <div style={{ fontWeight: 700, fontSize: 13 }}>Assistant Solv<span style={{ color: "#6E56CF" }}>ya</span></div>
                                <div style={{ fontSize: 11, color: "rgba(150,150,180,0.8)" }}>En ligne</div>
                            </div>
                        </div>
                        <button
                            type="button"
                            onClick={() => setOpen(false)}
                            style={{
                                background: "none", border: "none", cursor: "pointer",
                                color: "rgba(200,200,220,0.7)", fontSize: 18, lineHeight: 1,
                                padding: 4
                            }}
                        >✕</button>
                    </div>

                    {/* Messages */}
                    <div style={{
                        flex: 1,
                        overflowY: "auto",
                        padding: "14px 14px 8px",
                        display: "flex",
                        flexDirection: "column",
                        gap: 10
                    }}>
                        {messages.map((msg, i) => (
                            <div key={i} style={{
                                display: "flex",
                                justifyContent: msg.role === "user" ? "flex-end" : "flex-start"
                            }}>
                                <div style={{
                                    maxWidth: "80%",
                                    padding: "10px 13px",
                                    borderRadius: msg.role === "user" ? "14px 14px 4px 14px" : "14px 14px 14px 4px",
                                    background: msg.role === "user"
                                        ? "rgba(110,86,207,0.28)"
                                        : "rgba(255,255,255,0.06)",
                                    border: msg.role === "user"
                                        ? "1px solid rgba(110,86,207,0.4)"
                                        : "1px solid rgba(255,255,255,0.08)",
                                    fontSize: 13,
                                    lineHeight: 1.6,
                                    color: "rgba(225,225,240,0.95)",
                                    whiteSpace: "pre-wrap"
                                }}>
                                    {msg.content}
                                </div>
                            </div>
                        ))}

                        {loading && (
                            <div style={{ display: "flex", justifyContent: "flex-start" }}>
                                <div style={{
                                    padding: "10px 14px",
                                    borderRadius: "14px 14px 14px 4px",
                                    background: "rgba(255,255,255,0.06)",
                                    border: "1px solid rgba(255,255,255,0.08)",
                                    fontSize: 13,
                                    color: "rgba(180,180,200,0.7)"
                                }}>
                                    <span style={{ animation: "pulse 1s infinite" }}>…</span>
                                </div>
                            </div>
                        )}

                        {/* Bouton handoff */}
                        {showHandoff && !loading && (
                            <div style={{
                                marginTop: 4,
                                padding: "10px 12px",
                                borderRadius: 12,
                                border: "1px solid rgba(255,255,255,0.07)",
                                background: "rgba(255,255,255,0.03)",
                                fontSize: 12,
                                color: "rgba(180,180,200,0.8)",
                                textAlign: "center"
                            }}>
                                Pas satisfait de la réponse ?{" "}
                                <button
                                    type="button"
                                    onClick={() => { setOpen(false); onNavigate?.("contact"); }}
                                    style={{
                                        background: "none", border: "none",
                                        color: "#a78bfa", cursor: "pointer",
                                        fontSize: 12, padding: 0, textDecoration: "underline"
                                    }}
                                >
                                    Contacter le support
                                </button>
                            </div>
                        )}

                        <div ref={messagesEndRef} />
                    </div>

                    {/* Input */}
                    <div style={{
                        padding: "10px 12px",
                        borderTop: "1px solid rgba(255,255,255,0.07)",
                        display: "flex",
                        gap: 8,
                        alignItems: "flex-end"
                    }}>
                        <textarea
                            value={input}
                            onChange={e => setInput(e.target.value)}
                            onKeyDown={handleKeyDown}
                            placeholder="Posez votre question..."
                            rows={1}
                            style={{
                                flex: 1,
                                padding: "9px 12px",
                                borderRadius: 10,
                                border: "1px solid rgba(255,255,255,0.09)",
                                background: "rgba(255,255,255,0.05)",
                                color: "rgb(var(--text))",
                                fontSize: 13,
                                resize: "none",
                                outline: "none",
                                fontFamily: "inherit",
                                lineHeight: 1.5
                            }}
                        />
                        <button
                            type="button"
                            onClick={sendMessage}
                            disabled={!input.trim() || loading}
                            style={{
                                padding: "9px 14px",
                                borderRadius: 10,
                                border: "1px solid rgba(110,86,207,0.5)",
                                background: "rgba(110,86,207,0.25)",
                                color: "#fff",
                                cursor: "pointer",
                                fontSize: 14,
                                fontFamily: "inherit",
                                opacity: (!input.trim() || loading) ? 0.5 : 1,
                                transition: "all 160ms ease"
                            }}
                        >
                            ↑
                        </button>
                    </div>
                </div>
            )}

            {/* Bouton flottant */}
            <button
                type="button"
                onClick={() => setOpen(v => !v)}
                style={{
                    position: "fixed",
                    bottom: 24,
                    right: 24,
                    width: 50,
                    height: 50,
                    borderRadius: "50%",
                    border: "1px solid rgba(110,86,207,0.5)",
                    background: open
                        ? "rgba(110,86,207,0.35)"
                        : "rgba(110,86,207,0.22)",
                    color: "#fff",
                    fontSize: 22,
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    boxShadow: "0 8px 24px rgba(110,86,207,0.35)",
                    zIndex: 1001,
                    transition: "all 160ms ease"
                }}
            >
                {open ? "✕" : "💬"}
            </button>
        </>
    );
}
